<script lang="ts">
import { BuilderComponent } from '@/utils/cms';

export const LargeBodyTextRegistration: BuilderComponent = {
  name: 'Large Body Text',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Large Body text here' } },
    },
  ],
  inputs: [
    {
      name: 'underline',
      type: 'boolean',
      defaultValue: false,
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
defineProps<{
  underline?: boolean;
}>();
</script>

<template>
  <p
    class="text-base font-semibold large-text lg:text-lg lg:leading-6"
    :class="{ underline: underline }"
  >
    <slot />
  </p>
</template>

<style scoped>
.large-text {
  @apply mb-0;
}
</style>
